import {browserHistory} from 'react-router';

import {fetchPolicyLatestVersion} from 'app/policies/actions';
import {fetchProcedureLatestVersion} from 'app/procedures/actions';
import {fetchProcessLatestVersion} from 'app/process/actions';
import {appendPathToURL} from 'app/urls';
import {getLocation} from 'app/utils/urls';

import type {VersionableDocumentTypes} from 'app/general/types';
import type {AppDispatchType} from 'app/store/AppStore';
import type {AbstractVersionType} from 'app/version/types';

export const goToDocumentEditPage =
  (contentType: VersionableDocumentTypes, objectId: number, replace = false) =>
  (dispatch: AppDispatchType) => {
    const fetcher = {
      procedure: fetchProcedureLatestVersion,
      policy: fetchPolicyLatestVersion,
      proceduregroup: fetchProcessLatestVersion,
    }[contentType];
    const action = browserHistory[replace ? 'replace' : 'push'];
    return dispatch(fetcher(objectId)).then((version: {html_url: string}) => {
      const search = browserHistory.getCurrentLocation().search;
      action(getLocation(appendPathToURL(version.html_url + search, 'edit/')));
    });
  };

type GoRTKProps = {
  version: {html_url: string};
};

export const goToDocumentEditPageRTK = ({version}: GoRTKProps) => {
  const search = browserHistory.getCurrentLocation().search;
  browserHistory.push(
    getLocation(appendPathToURL(version.html_url + search, 'edit/'))
  );
};

interface GenericVersion {
  id: number;
}

export function isLastVersion<T extends GenericVersion>(
  version: T | null,
  versions: Array<T>
) {
  return (
    version != null && versions.length > 0 && version.id === versions[0].id
  );
}

export function groupVersions<T extends AbstractVersionType>(
  versions: Array<T>
): Array<Array<T>> {
  const items: Array<Array<T>> = [];

  for (let i = 0; i < versions.length; i++) {
    const version = versions[i];

    if (version.approved_at != null || i == 0 || version.editor == null) {
      items.push([version]);
    } else {
      const lastGroup = items[items.length - 1];
      const lastVersion = lastGroup[0];

      if (
        lastVersion &&
        lastVersion.editor &&
        lastVersion.editor.id === version.editor.id
      ) {
        lastGroup.push(version);
      } else {
        items.push([version]);
      }
    }
  }

  return items;
}
